<template>
<div class="chapter">
<div class="inner_page">
<blockquote>
<p class="noind sgc-1" id="epigraph"><a id="start"></a><i>If a man cannot forget, he will never amount to much.</i></p>
<p class="ind">Søren Kierkegaard, <i>Either/Or</i></p>
<p class="noind sgc-2">… We know now that the modern world is coming to an end… at the same time, the unbeliever will emerge from the fogs of secularism. He will cease to reap benefit from the values and forces developed by the very Revelation he denies… Loneliness in faith will be terrible. Love will disappear from the face of the public world, but the more precious will be that love which flows from one lonely person to another… the world to come will be filled with animosity and danger, but it will be a world open and clean.</p>
<p class="ind">Romano Guardini, <i>The End of the Modern World</i></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-start.vue?79b01230